import { ReactElement } from 'react';

import { Close } from '@calm-web/icons';

import { Optional } from '../../utils/types';
import { ButtonSizes } from '../Button';
import { StyledButton } from './styles';
import { IconButtonProps } from './types';

const IconButton = ({
	backgroundColor = 'transparent',
	color = 'black',
	width,
	height,
	...props
}: IconButtonProps): ReactElement => {
	return (
		<StyledButton
			backgroundColor={backgroundColor}
			iconColor={color}
			size={ButtonSizes.Md}
			$width={width}
			$height={height}
			{...props}
		/>
	);
};

export const CloseButton = ({
	Icon = Close,
	...props
}: Omit<Optional<IconButtonProps, 'aria-label'>, 'Icon'> & { Icon?: React.FC }): ReactElement => (
	<IconButton aria-label="close" {...props} Icon={Icon} />
);

export default IconButton;
